import {
    Box,
    Input,
    Text,
    HStack,
} from "@chakra-ui/react";

import {
    Search,
} from "lucide-react";

const FAQSearch = ({
    search,
    setSearch,
}) => {
    return (
        <Box mb={10}>
            <Box
                position="relative"
            >
                <Input
                    pl="45px"
                    h="56px"
                    bg="white"
                    placeholder="Search for questions about earnings, verification or safety..."
                    value={search}
                    onChange={(e) =>
                        setSearch(
                            e.target.value
                        )
                    }
                />

                <Box
                    position="absolute"
                    left="16px"
                    top="18px"
                >
                    <Search
                        size={18}
                    />
                </Box>
            </Box>

            <HStack
                mt={4}
                gap={4}
                justify="center"
                wrap="wrap"
            >
                <Text
                    color="#2453FF"
                    fontSize="sm"
                >
                    Weekly Payouts
                </Text>

                <Text
                    color="#2453FF"
                    fontSize="sm"
                >
                    Verification
                </Text>

                <Text
                    color="#2453FF"
                    fontSize="sm"
                >
                    Tip Safety
                </Text>
            </HStack>
        </Box>
    );
};

export default FAQSearch;